(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chunks-collection-grid"] && !Shopify.designMode) return;
  try {
    
/* ---------------------------------------------------------------
   Load more — pulls the next page through the Section Rendering API
   and appends the new cards. Falls back to a normal page load if the
   fetch fails, so the button never dead-ends.
---------------------------------------------------------------- */
document.addEventListener('click', function (e) {
  var more = e.target.closest('.ccg-loadmore');
  if (!more) return;
  e.preventDefault();

  var nextUrl = more.getAttribute('data-next-url');
  var sectionId = more.getAttribute('data-section-id');
  if (!nextUrl || more.classList.contains('is-loading')) return;

  var root = more.closest('[data-ccg-root]');
  var grid = root ? root.querySelector('.ccg-grid') : null;
  if (!grid) { window.location.href = nextUrl; return; }

  var original = more.textContent.trim();
  more.classList.add('is-loading');
  more.textContent = more.getAttribute('data-loading-label') || 'Loading...';

  var fetchUrl = nextUrl + (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);

  fetch(fetchUrl, { credentials: 'same-origin' })
    .then(function (res) {
      if (!res.ok) throw new Error('Load more failed: ' + res.status);
      return res.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('.ccg-grid');
      if (!newGrid) throw new Error('No grid in response');

      var cards = newGrid.children;
      while (cards.length) { grid.appendChild(cards[0]); }

      var nextBtn = doc.querySelector('.ccg-loadmore');
      var shown = root.querySelector('[data-ccg-shown]');
      var newShown = doc.querySelector('[data-ccg-shown]');

      if (shown) {
        shown.textContent = newShown ? newShown.textContent : String(grid.children.length);
      }

      if (nextBtn && nextBtn.getAttribute('data-next-url')) {
        more.setAttribute('data-next-url', nextBtn.getAttribute('data-next-url'));
        more.setAttribute('href', nextBtn.getAttribute('data-next-url'));
        more.classList.remove('is-loading');
        more.textContent = original;
      } else {
        // Last page: drop the button, keep the count line.
        more.remove();
        if (shown && shown.parentNode) { shown.parentNode.textContent = 'Showing all ' + grid.children.length + ' products'; }
      }
    })
    .catch(function (err) {
      console.error('[CCG load more]', err);
      window.location.href = nextUrl;
    });
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('.ccg-add[data-variant-id]');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  var original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
  .then(function (res) {
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    return res.json();
  })
  .then(function () {
    btn.textContent = 'Added!';

    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: 'add_to_cart',
      event_category: 'chunks_collection',
      event_label: btn.getAttribute('data-title'),
      currency: btn.getAttribute('data-currency'),
      value: parseFloat(btn.getAttribute('data-price') || '0'),
      items: [{
        item_id: btn.getAttribute('data-id'),
        item_name: btn.getAttribute('data-title'),
        price: parseFloat(btn.getAttribute('data-price') || '0'),
        quantity: 1,
        item_list_name: 'Chunks & Chips Collection'
      }]
    };
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') { window.gtag('event', 'add_to_cart', payload); }

    if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') { window.Rebuy.SmartCart.show(); }
    if (window.Rebuy && window.Rebuy.eventBus && typeof window.Rebuy.eventBus.$emit === 'function') { window.Rebuy.eventBus.$emit('cart:open'); }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));

    setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800);
  })
  .catch(function (err) {
    console.error('[CCG ATC]', err);
    btn.disabled = false;
    btn.textContent = original;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gmc-category-pills"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var pill = e.target.closest('.gmc-pill');
  if (!pill) return;
  var href = pill.getAttribute('href') || '';
  if (href.charAt(0) !== '#') return;

  var target = document.getElementById(href.slice(1));
  if (!target) return;

  e.preventDefault();
  var nav = pill.closest('.gmc-pills');
  var offset = 0;
  if (nav && getComputedStyle(nav).position === 'sticky') {
    offset = nav.getBoundingClientRect().height + 8;
  }
  var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
  window.scrollTo({ top: y, behavior: 'smooth' });

  nav.querySelectorAll('.gmc-pill.is-active').forEach(function (p) { p.classList.remove('is-active'); });
  pill.classList.add('is-active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gmc-collection-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.gmc-add[data-variant-id]');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;

  var original = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    credentials: 'same-origin',
    body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
  })
  .then(function (res) {
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    return res.json();
  })
  .then(function () {
    btn.textContent = 'Added!';
    if (window.Rebuy && window.Rebuy.SmartCart) { window.Rebuy.SmartCart.show(); }
    if (window.Rebuy && window.Rebuy.eventBus) { window.Rebuy.eventBus.$emit('cart:open'); }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 1800);
  })
  .catch(function (err) {
    console.error('[GMC ATC]', err);
    btn.disabled = false;
    btn.textContent = original;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gmc-shop-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScroller(scroller) {
    var track = scroller.querySelector('.gmc-snav-track');
    if (!track) return;
    function update() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      scroller.classList.toggle('has-more-right', track.scrollLeft < maxScroll - 1);
      scroller.classList.toggle('has-more-left', track.scrollLeft > 1);
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  document.querySelectorAll('.gmc-snav-scroller').forEach(initScroller);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products-section"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
